/* global window */
import { createAction } from 'redux-actions'
import * as types from './types'
import AuthServices from '../services/AuthServices'
import UserServices from '../services/UserService'
import { ONE_SIGNAL_API_KEY, IS_PRD } from '../utils/apiConstants'
import { USER_CONTACT_TYPE } from '../reducers/userContact'


export const fetchUser = () => (
  (dispatch) => {
    dispatch(createAction(types.IS_APPLICATION_LOADING)(true))
    UserServices
      .fetchUser()
      .then((result) => {
        dispatch(createAction(USER_CONTACT_TYPE)(result))
        dispatch(createAction(types.IS_APPLICATION_LOADING)(false))
        dispatch(createAction(types.FETCH_USER_INFORMATION)(result))
      })
      .catch((err) => {
        console.log(err)
      })
  }
)

export const saveUserPushToken = () => (
  () => {
    const OneSignal = window.OneSignal || []
    if (IS_PRD) {
      OneSignal.push(() => {
        OneSignal.init({
          appId: ONE_SIGNAL_API_KEY,
          allowLocalhostAsSecureOrigin: true,
        })
        OneSignal.getUserId()
          .then((playerId) => {
            UserServices
              .saveUserPushToken(playerId)
              .then(() => {
                console.log('push registration saved!')
              })
              .catch((err) => {
                console.log(err)
              })
          })
      })
    }
  }
)

export const refreshUserToken = () => (
  (dispatch) => {
    dispatch(createAction(types.IS_APPLICATION_LOADING)(true))
    AuthServices
      .refreshUserToken({})
      .then((result) => {
        dispatch(createAction(types.AUTH_USER_COMPLETE)({ ...result }))
        // TODO: ao inves de chamar o / verificar a última request feita e voltar nela
        return dispatch(createAction(types.IS_APPLICATION_LOADING)(false))
      })
      .catch(() => {
        dispatch(createAction(types.IS_APPLICATION_LOADING)(false))
      })
  }
)

export const loadLocalUser = () => (
  (dispatch) => {
    dispatch(createAction(types.LOAD_LOCAL_USER)())
  }
)
